module.exports = __webpack_public_path__ + "9788f41e/img/comments-icon.fdec7fdb.svg";